export default "__VITE_ASSET__DkSlDkFR__"